/**
 * Created by lk on 17/6/4.
 */
import axios from "../../utils/axios";

// 谁最懂我相关

// 列表
export function lsList(query) {
    return axios({
        url: "/admin/ls/ls/index",
        method: "get",
        params: query
    });
}

// 保存
export function lsSave(data, formName, method = "post") {
    var url = formName === "add" ? "/admin/ls/ls/save" : "/admin/ls/ls/edit";
    return axios({
        url: url,
        method: method,
        data: data
    });
}

// 删除
export function lsDelete(data) {
    return axios({
        url: "/admin/ls/ls/delete",
        method: "post",
        data: data
    });
}

// 物流公司
export function lcList() {
    return axios({
        url: "/admin/home/lc",
        method: "get"
    });
}

// 批量上传
export function lcbatch(data) {
    return axios({
        url: "admin/ls/ls/batch",
        method: "post",
        data:data
    });
}

// 批量上传模板二
export function lcbatch2(data) {
    return axios({
        url: "admin/ls/ls/batchTpl2",
        method: "post",
        data:data
    });
}

// 列表上传压缩包
export function lcuploadZip(data) {
    return axios({
        url: "/admin/ls/ls/uploadZip",
        method: "post",
        data:data
    });
}
